import { initAiCatalog } from 'ee/ai/catalog/';

initAiCatalog();
